import { createAsyncThunk } from '@reduxjs/toolkit';
import { Interaction } from '@constants';
import { BiToastType } from '@services/BiLogger';
import { toastsActions } from '../../toast';
import { type ThunkApiConfig } from '../../store.types';
import { type MarkPrimaryThunk } from './types';

export const markSavedPaymentMethodPrimary = createAsyncThunk<
  void,
  MarkPrimaryThunk,
  ThunkApiConfig
>(
  'savedPaymentMethods/markPrimary',
  async ({ paymentMethodId }, { extra, dispatch, rejectWithValue }) => {
    const { flowAPI, savedPaymentMethodsApi } = extra;
    const { environment, errorHandler, panoramaClient } = flowAPI;

    try {
      if (environment.isViewer) {
        await savedPaymentMethodsApi.markAsPrimary(paymentMethodId);
      }

      panoramaClient.transaction(Interaction.MarkAsPrimary).finish();
    } catch (error) {
      const resolvedError = errorHandler.getResolvedError(error);

      dispatch(
        toastsActions.showToast({
          text: resolvedError.message,
          meta: { action: BiToastType.MarkPrimaryError, skin: 'error' },
        }),
      );

      if (error instanceof Error) {
        panoramaClient.logger().error(Interaction.MarkAsPrimary, { error });
        panoramaClient.errorMonitor().reportError(error);
      }

      throw rejectWithValue({ error });
    }
  },
);
